module.exports = __webpack_public_path__ + "static/img/not-found-icon.a7ff9e1d.svg";